import {PartTypeApiDto} from "./_RestModels";

export default class PartType {
    constructor(public readonly id: string, public readonly typeId: string) {
    }

    public static fromJson(json: PartTypeApiDto): PartType {
        return new PartType(json.id, json.typeId)
    }
}